import * as gridlines from "../operations/hide_gridlines";

export function hideGridlines(state){
	gridlines.hideGridlines(this,state);
}